import { render, staticRenderFns } from "./GdprEditDialog.vue?vue&type=template&id=2551adda&scoped=true&"
import script from "./GdprEditDialog.vue?vue&type=script&lang=js&"
export * from "./GdprEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./GdprEditDialog.vue?vue&type=style&index=0&id=2551adda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2551adda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMessages } from 'vuetify/lib/components/VMessages';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAlert,VBtn,VCardActions,VCardText,VDialog,VDivider,VForm,VIcon,VMessages,VRow,VTextField,VToolbar,VToolbarItems})
